import { ModalMain } from "../styled";
import { FontGreyDarkMediumTitle } from "../../../../utils/typografyApp";
import SecondaryButton from "../../SecondaryButton";
import PrimaryButton from "../../PrimaryButton";
import { NewAssetForm } from "./styled";
import Select from '../../Select'
import map_icon from '../../../../assets/icons/map.svg'
import { useNewAssetModalHook } from "./hook";
import Input from "../../Input";
import { FormProvider } from "react-hook-form";

const NewAssetModel = ({ onClose, selectedAsset3DItem }) => {

    const hook = useNewAssetModalHook({ onClose, selectedAsset3DItem });

    return (
        <ModalMain>
            <FormProvider {...hook.form.assetForm}>
                <NewAssetForm>
                    <form onSubmit={hook.form.assetForm.handleSubmit(hook.form.onSubmit)}>
                        <div className={"menu-content"}>
                            <div className="content">
                                <div className="title">
                                    <FontGreyDarkMediumTitle>Cadastro de Ativo</FontGreyDarkMediumTitle>
                                </div>
                                {/* 
                                    <label className="profilePic" htmlFor="profilePic">
                                        <img src={profilePic || upload_input_icon} alt="Icone de Upload"/>
                                        <input 
                                            className="hidden-content" id="profilePic" type="file" 
                                            onChange={async (e)=> setProfilePic(await controller.onChangeFile(e))}
                                        />
                                    </label> 
                                */}

                                <div className="row">
                                    <Input type="text" placeholder="Nome do ativo" name="name" />
                                    <Input type="text" placeholder="Tag" name="tag" className={"tag"} />
                                </div>

                                <div className="row">
                                    <Select
                                        type="text"
                                        placeholder="Selecione a Unidade"
                                        name="unit"
                                        options={hook.units.unitsData}
                                    />

                                    {/* <Select
                                        type="text"
                                        placeholder="Selecione o Grupo"
                                        name="group"
                                        options={groupOptions}
                                        selectedOption={asset.group}
                                        setSelectedOption={(selectedOption) => setAsset({ ...asset, group: selectedOption })}
                                        error={''}
                                    /> */}
                                </div>

                                <div className="row">
                                    <Input type="text" name='lat' placeholder="Latitude" />
                                    <Input type="text" name='lng' placeholder="Longitude" />

                                    {/* <div className="map">
                                        <input className="rot" type="text" name='rotation' placeholder="Rotação" />
                                        <img src={map_icon} alt="Icone ver no mapa" title={'Ver no mapa'} />
                                    </div> */}
                                </div>

                                <div className="row">
                                    {/* <Select
                                        type="text"
                                        placeholder="3D do Ativo"
                                        name="group"
                                        options={stlOptions}
                                        selectedOption={asset.model3d}
                                        setSelectedOption={(selectedOption) => setAsset({ ...asset, model3d: selectedOption })}
                                        error={''}
                                    /> */}
                                </div>

                            </div>

                            <div className="actions-container">
                                <SecondaryButton onClick={onClose}>Voltar</SecondaryButton>
                                <PrimaryButton onClick={onClose}>Criar</PrimaryButton>
                            </div>
                        </div>
                    </form>
                </NewAssetForm>
            </FormProvider>
        </ModalMain>
    );
}

export default NewAssetModel;